import * as React from "react";
import {
  Card,
  Title,
  InputTexto,
  InputFecha,
  InputSelect,
  TextLink,
  Button,
  Alert,
} from "../components";
import "../css/pages/ModificacionEstados.css";
import "../css/search-filter/Filter.css";
import "../css/search-result/ResultTable.css";
import { EntidadRecaudadora } from "../enums-lists/EntidadRecaudadora";
import {
  RutValidator,
  FormatRutValidator,
  ErrorValidations,
} from "../enums-lists/Validations";
import { getApiDateFormat } from "../functions/Format";
import { getPaymentList, paymentUpdateStatusAction } from "../services/api-ssrr/CollectionManagerAPIClient";
import { PaymentModel } from "../types-interfaces/types";
import { getStatusTypeByIds } from "../enums-lists/StatusType";
import { TableSubtitleStyle } from "../components/styles/TitleStyle";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { useState, useEffect } from "react";
import { paymentStateUpdateColumns } from "../enums-lists/TableColumns";
import ResultsPerPage from "../enums-lists/ResultsPerPage";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { UserState, GroupedPaymentType } from "../types-interfaces/interfaces";
import { useAppDispatch } from "../redux/hooks";
import {
  fetchPaymentTypes,
  selectPaymentTypes,
} from "../redux/slices/paymentType/PaymentTypeSlice";
import { splitValue } from "../functions/Data";
import Modal from "../components/modal/Modal";
import ModalUpdatePayment from "../components/modal/ModalUpdatePayment";

interface ModificacionEstadosProps {
  className?: string | undefined;
  data?: Array<Array<string>>;
  headersName?: Array<string>;
}

interface ModificacionEstadoState {
  rut?: string;
  estadoModificacionEstado?: number;
  entidadRecaudadora?: number;
  medioPago?: string;
  fechaInicio?: string;
  fechaFin?: string;
  tableData?: Array<PaymentModel>;
  resultsNumber?: number;
  calendarHiddenInicio?: boolean;
  calendarHiddenFin?: boolean;
  errorRut?: string;
  alertVariant?:
    | "error"
    | "warning"
    | "information"
    | "success"
    | "banner"
    | undefined;
  errorFechaInicio?: string | undefined;
  errorFechaFin?: string | undefined;
  consultaSinDatos?: boolean;
  alertText?: string | undefined;
  paymentTypes: Array<GroupedPaymentType>;
  currentStateModifier: string;
  modalIsOpen: boolean;
  currentPaymentToUpdate?: PaymentModel | undefined;
}

const initialModificacionEstadoState: ModificacionEstadoState = {
  rut: "",
  estadoModificacionEstado: 0,
  entidadRecaudadora: 0,
  medioPago: "0",
  fechaInicio: new Date().toLocaleDateString().replaceAll("-", "/"),
  fechaFin: "",
  tableData: [],
  resultsNumber: undefined,
  calendarHiddenInicio: true,
  calendarHiddenFin: true,
  alertVariant: undefined,
  errorFechaInicio: "",
  errorFechaFin: "",
  alertText: "",
  paymentTypes: [{ value: 0, name: "Cargando..." }],
  currentStateModifier: "open",
  modalIsOpen: false,
  currentPaymentToUpdate: undefined
};

const fechaCiclo = new Date(); //TODO: arreglar fecha ciclo
const fechaMin = new Date();
fechaMin.setMonth(fechaMin.getMonth() - 6);

const dateValidator = (fechainicio?: string) => (fechafin?: string) => {
  if (fechafin && fechafin?.length < 10) {
    return undefined;
  }

  let val = false;

  if (
    fechafin &&
    fechafin !== initialModificacionEstadoState.fechaFin &&
    fechainicio
  ) {
    val =
      Date.parse(fechafin.split("/").reverse().join()) <
      Date.parse(fechainicio.split("/").reverse().join());
  }

  return val ? ErrorValidations.EndDateGT : undefined;
};

function ModificacionEstados(props: ModificacionEstadosProps) {
  const [state, setState] = useState(initialModificacionEstadoState);
  const userState = useSelector<RootState, UserState>(
    (state) => state.userState
  );

  const [pagination, setPagination] = React.useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [pageCount, setPageCount] = React.useState(0);
  const [rowCount, setRowCount] = React.useState(0);

  React.useEffect(() => {
    if ((pageCount !== 0 && rowCount !== 0 && pagination.pageIndex !== 0) || (pagination.pageIndex === 0 && pageCount !== 0)) {
      llamadaAPI(pagination.pageIndex+1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination]);
  const [isLoadingTable, setIsLoadingTable] = React.useState(false);

  const statusTypes = getStatusTypeByIds([0,1,3]);

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchPaymentTypes(userState, true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const paymentTypesFromAPI = useSelector<
    RootState,
    {
      loading: boolean;
      paymentTypes: Array<GroupedPaymentType>;
      error?: boolean;
    }
  >(selectPaymentTypes);

  useEffect(() => {
    setState({ ...state, paymentTypes: paymentTypesFromAPI.paymentTypes });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentTypesFromAPI]);

  function handleModal(type: string, isOpen: boolean, row?: PaymentModel) {
    if (type !== "open") {
      setState({ ...state, currentStateModifier: type, modalIsOpen: isOpen, currentPaymentToUpdate: row });
    }
  }

  async function handleConfirm(paymentId: string, action: string) {
    var actionValue = 0;
    if (action === "Desvincular") {
      actionValue = 1;
    } else if (action === "Devolver") {
      actionValue = 2;
    } else {
      actionValue = 3; // anular
    }

    const result = await paymentUpdateStatusAction({paymentIds: [paymentId], action: actionValue}, userState.currentSession?.accessToken!, userState.currentSession?.user?.email!);

    if (typeof(result) === "string"){
      setState({
        ...state,
        modalIsOpen: false,
        alertVariant: "error",
        alertText: result
      });
    } else {
      if (result.length > 0){         
        setState({
          ...state,
          modalIsOpen: false,
          alertVariant: "error",
          alertText: "El pago no pudo ser cambiado de estado"
        });
      } else {
        setState({
          ...state,
          modalIsOpen: false,
          alertVariant: "success",
          alertText: "Pago modificado exitosamente",
          consultaSinDatos: true,
          tableData: [],
        });
      }
    }
  }

  function rutChangeHandler(evt: React.ChangeEvent<HTMLInputElement>) {
    let newRut = evt.currentTarget.value.toUpperCase();
    let oldRut = state.rut ?? newRut.substring(0, newRut.length - 1);
    const regexp = new RegExp("^[0-9K-]+$");
    if (
      (newRut && !regexp.test(newRut)) ||
      newRut.startsWith("0") ||
      newRut.startsWith("K") ||
      (newRut.includes("-") &&
        newRut.split("-").length > 1 &&
        newRut.split("-")[1].length > 1) ||
      (newRut.includes("-") &&
        newRut.lastIndexOf("-") !== newRut.indexOf("-")) ||
      (newRut.includes("K") && newRut.lastIndexOf("K") !== newRut.indexOf("K"))
    ) {
      evt.currentTarget.value = oldRut;
    } else {
      setState({ ...state, rut: newRut });
    }
  }

  function estadoPagoChangeHandler(evt: React.ChangeEvent<HTMLSelectElement>) {
    setState({
      ...state,
      estadoModificacionEstado: parseInt(evt.currentTarget.value),
    });
  }

  function entidadRecaudadoraChangeHandler(
    evt: React.ChangeEvent<HTMLSelectElement>
  ) {
    setState({
      ...state,
      entidadRecaudadora: parseInt(evt.currentTarget.value),
    });
  }

  function medioPagoChangeHandler(evt: React.ChangeEvent<HTMLSelectElement>) {
    setState({ ...state, medioPago: evt.currentTarget.value });
  }

  function limpiarFiltroHandler(evt: React.MouseEvent<HTMLInputElement>) {
    setState({
      ...state,
      rut: initialModificacionEstadoState.rut,
      estadoModificacionEstado:
        initialModificacionEstadoState.estadoModificacionEstado,
      entidadRecaudadora: initialModificacionEstadoState.entidadRecaudadora,
      medioPago: initialModificacionEstadoState.medioPago,
      fechaInicio: initialModificacionEstadoState.fechaInicio,
      fechaFin: initialModificacionEstadoState.fechaFin,
    });
  }

  function handleClickGenerarConsulta(
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) {
    let error = false;
    let newState = state;
    //validaciones
    if (newState.fechaInicio === "") {
      error = true;
      newState.errorFechaInicio = ErrorValidations.Required;
    }

    if (newState.fechaFin === "") {
      setState({
        ...state,
        fechaFin: fechaCiclo.toLocaleDateString().replaceAll("-", "/"),
      });
    }

    if (
      newState.fechaInicio &&
      newState.fechaFin &&
      Date.parse(newState.fechaFin.split("/").reverse().join()) <
        Date.parse(newState.fechaInicio.split("/").reverse().join())
    ) {
      newState.errorFechaFin = ErrorValidations.EndDateGT;
    }

    if (
      error ||
      newState.errorFechaInicio !== "" ||
      newState.errorFechaFin !== ""
    ) {
      setState(newState);
      return;
    }

    setPageCount(0);
    setRowCount(0);

    setPagination({
      pageIndex: 0,
      pageSize: pagination.pageSize
    });

    llamadaAPI(1);
  }

  function getFilters(): { filter: string; filterQuantity: number } {
    let filter = "";
    let filterQuantity = 0;

    if (state.rut) {
      filter += `&customerId=${state.rut}`;
      filterQuantity++;
    }

    if (state.estadoModificacionEstado) {
      filter += `&status=${state.estadoModificacionEstado}`;
      filterQuantity++;
    } else {
      filter += `&multipleStatus=1,3`;
      filterQuantity++;
    }

    if (state.entidadRecaudadora) {
      filter += `&companyType=${state.entidadRecaudadora}`;
      filterQuantity++;
    }

    const medioPago = splitValue(state.medioPago || "");

    if (state.medioPago !== "0") {
      const medioPagoFiltered = medioPago[0];
      filter += `&paymentType=${medioPagoFiltered}`;
      filterQuantity++;

      if (1 in medioPago) {
        const medioPagoTokuFiltered = medioPago[1];
        filter += `&tokuPaymentType=${medioPagoTokuFiltered}`;
        filterQuantity++;
      }
    }

    if (state.fechaInicio) {
      filter += `&dateFrom=${getApiDateFormat(state.fechaInicio)}`;
    }

    if (state.fechaFin) {
      filter += `&dateTo=${getApiDateFormat(state.fechaFin)}`;
    }

    return { filter, filterQuantity };
  }

  async function llamadaAPI(page: number) {
    let filters = getFilters();
    let params = `page=${page}&size=${pagination.pageSize}&user=1&collectionAmount=1` + filters.filter;
    
    setIsLoadingTable(true);
    let result = await getPaymentList(
      params,
      userState.currentSession?.accessToken!,
      userState.currentSession?.user?.email!
    );
    setIsLoadingTable(false);

    if (
      !result ||
      typeof result === "string" ||
      !result.result ||
      result.result.length === 0
    ) {
      setState({
        ...state,
        alertVariant: "error",
        alertText:
          "No se encontró información disponible. Por favor intente nuevamente, recomendamos modificar los filtros de consulta.",
        consultaSinDatos: true,
        tableData: [],
      });
      return;
    }

    let finalResult:PaymentModel[] = [];
    
    finalResult.push(...result.result);

    for (let i = 0; i < result.result.length; i++) {
      if (result.result[i].status !== "Recaudada") {
        finalResult[i].paymentConfirmDate = "";
      }
    }

    setRowCount(result.paging.total);
    setPageCount(result.paging.pages);

    setState({
      ...state,
      alertVariant: undefined,
      alertText: "",
      consultaSinDatos: false,
      tableData: finalResult,
      resultsNumber: result.paging.total,
    });
  }

  function handlerChangeDate(
    e: React.ChangeEvent<HTMLInputElement>,
    date: string
  ): void {
    let oldDate =
      date === "fecha-fin" ? state.fechaFin ?? "" : state.fechaInicio ?? "";
    let newDate = e.currentTarget.value;
    const regexp = RegExp("^[0-9/]+$");

    if (
      (newDate && !regexp.test(newDate)) ||
      (newDate.split("/").length === 1 &&
        parseInt(newDate.split("/")[0]) > 31) ||
      (newDate.split("/").length === 2 &&
        parseInt(newDate.split("/")[1]) > 12) ||
      (newDate.split("/").length === 3 && newDate.split("/")[2].length > 4) ||
      (newDate.match(/\//g)?.length === 1 && newDate.indexOf("/", 0) !== 2) ||
      (newDate.match(/\//g)?.length === 2 && newDate.indexOf("/", 3) !== 5) ||
      (newDate.match(/\//g)?.length ?? 0) > 2 ||
      newDate.length > 10
    ) {
      e.currentTarget.value = oldDate;
    } else {
      let error =
        newDate.length > 0 && isInvalidDate(newDate)
          ? ErrorValidations.InvalidDate
          : newDate.length > 0 && newDate.length < 10
          ? ErrorValidations.Required
          : "";
      if (date === "fecha-inicio") {
        setState({
          ...state,
          fechaInicio: newDate,
          errorFechaInicio: error,
          calendarHiddenInicio: true,
        });
      } else {
        setState({
          ...state,
          fechaFin: newDate,
          errorFechaFin: error,
          calendarHiddenFin: true,
        });
      }
    }
  }

  function isInvalidDate(date: string): boolean {
    const [day, month, year] = date.split("/");
    const dateObj = new Date(+year, +month - 1, +day);
    return !(
      dateObj.toLocaleString("es-CL").substring(0, 10).replaceAll("-", "/") ===
      date
    );
  }

  const paymentTable = useMaterialReactTable({
    columns: paymentStateUpdateColumns(handleModal),
    data: state.tableData ?? [],
    onPaginationChange: setPagination,
    state: { pagination: pagination, isLoading: isLoadingTable },
    rowCount: rowCount,
    pageCount: pageCount,
    localization: {
      rowsPerPage: "Registros por página",
      showHideSearch: "mostrar / ocultar búsqueda",
      search: "Búsqueda",
      sortByColumnAsc: "Ordernar por {column} ascendente",
      sortByColumnDesc: "Ordernar por {column} descendente",
      sortedByColumnAsc: "Ordernado por {column} ascendente",
      sortedByColumnDesc: "Ordernado por {column} descendente",
    },
    muiTableContainerProps: {
      sx: { maxHeight: '35em' },      
    },
    muiBottomToolbarProps: {
      style: {
        marginBottom: "25px",
      },
    },
    muiPaginationProps: {
      rowsPerPageOptions: ResultsPerPage,
      showRowsPerPage: true,
      shape: "rounded",
      variant: "text",
      style: {
        color: "#333",
        fontFeatureSettings: "'clig' off, 'liga' off",
        fontFamily: "FS Elliot Pro Regular",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "21px",
        padding: "13px",
      },
      property: "background-color: black",
      SelectProps: {
        style: {
          gap: "8px",
          padding: "13px",
          color: "#333",
          fontFeatureSettings: "'clig' off, 'liga' off",
          fontFamily: "FS Elliot Pro Regular",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: "400",
          lineHeight: "21px",
        },
      },
    },
    paginationDisplayMode: "pages",
    enableColumnActions: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableHiding: false,
    enableFilters: true,
    enableColumnFilters: false,
    enablePagination: true,
    manualPagination: true
  });

  return (
    <div className={props.className}>
      <Title
        className={props.className + "-title"}
        text="Modificación de Estado"
      />
      {state.alertText && (
        <Alert
          className={props.className + "-alert"}
          type={state.alertVariant}
          text={state.alertText}
          alt="alert"
          onClose={() => {
            setState({ ...state, alertText: "", alertVariant: undefined });
          }}
        />
      )}
      <Card className="filter">
        <Card className="filter-row">
          <InputTexto
            className="filter-input"
            label="Filtrar por RUT del cliente"
            value={state.rut}
            onChange={rutChangeHandler}
            validators={[FormatRutValidator, RutValidator]}
            error={state.errorRut}
            alt="rut"
          />
          <InputSelect
            className="filter-select"
            label="Filtrar por estado de pago"
            value={state.estadoModificacionEstado}
            onChange={estadoPagoChangeHandler}
            values={statusTypes}
            data-testid="estado de pago"
          />
          <InputSelect
            className="filter-select"
            label="Filtrar por entidad recaudadora"
            value={state.entidadRecaudadora}
            onChange={entidadRecaudadoraChangeHandler}
            values={EntidadRecaudadora}
            data-testid="entidad recaudadora"
          />
          <InputSelect
            className="filter-select"
            label="Filtrar por medio de pago"
            value={state.medioPago}
            onChange={medioPagoChangeHandler}
            values={state.paymentTypes}
            data-testid="medio de pago"
          />
        </Card>
        <Card className="filter-row">
          <InputFecha
            className="filter-fecha"
            label="Filtrar por fecha desde"
            formatlabel="Usar el formato: DD/MM/AAAA"
            value={state.fechaInicio}
            calendarhidden={state.calendarHiddenInicio}
            calendarmaxdate={fechaCiclo}
            calendarmindate={fechaMin}
            onClickDay={(e) => {
              setState({
                ...state,
                fechaInicio: e.toLocaleDateString().replaceAll("-", "/"),
                calendarHiddenInicio: true,
                errorFechaInicio: "",
              });
            }}
            onClick={() => {
              setState({
                ...state,
                calendarHiddenInicio: !state.calendarHiddenInicio,
                calendarHiddenFin: true,
              });
            }}
            onMouseOver={() =>
              setState({ ...state, calendarHiddenInicio: true })
            }
            alt="fecha-inicio"
            error={state.errorFechaInicio}
            onChange={(e) => handlerChangeDate(e, "fecha-inicio")}
          />
          <InputFecha
            className="filter-fecha"
            label="Filtrar por fecha hasta"
            formatlabel="Usar el formato: DD/MM/AAAA"
            value={state.fechaFin}
            calendarhidden={state.calendarHiddenFin}
            calendarmaxdate={fechaCiclo}
            calendarmindate={fechaMin}
            onClickDay={(e) => {
              setState({
                ...state,
                fechaFin: e.toLocaleDateString().replaceAll("-", "/"),
                calendarHiddenFin: true,
                errorFechaFin: "",
              });
            }}
            onClick={() => {
              setState({
                ...state,
                calendarHiddenFin: !state.calendarHiddenFin,
                calendarHiddenInicio: true,
              });
            }}
            onMouseOver={() => setState({ ...state, calendarHiddenFin: true })}
            validators={[dateValidator(state.fechaInicio)]}
            alt="fecha-fin"
            error={state.errorFechaFin}
            onChange={(e) => handlerChangeDate(e, "fecha-fin")}
          />
          <TextLink
            className="filter-limpiar"
            text="Limpiar filtros X"
            onClick={limpiarFiltroHandler}
          />
        </Card>
      </Card>
      <Button
        className={props.className + "-button"}
        text="Generar Consulta"
        onClick={handleClickGenerarConsulta}
      />
      <div className="result">
        {((state.tableData && state.tableData.length > 0) || isLoadingTable) && (
          <>
            <Title
              text={`Resultado de la busqueda`}
              style={TableSubtitleStyle}
            />
            <MaterialReactTable table={paymentTable} />
          </>
        )}
        <div style={{ height: "100px" }}>&nbsp;</div>
      </div>
      <Modal
        isOpen={state.modalIsOpen}
        hasCloseBtn={true}
        onClose={() => handleModal("close", false, undefined)}
        children={
          <ModalUpdatePayment
            payment={state.currentPaymentToUpdate}
            action={state.currentStateModifier}
            handleConfirm={handleConfirm}
            handleCloseModal={() => handleModal("close", false, undefined)}
          />
        }
      />
    </div>
  );
}

export default ModificacionEstados;
